import React from 'react'
import './Footer.sass'
import Logo from '../../ui/Logo/Logo'
import SocialLinks from '../Top/SocialLinks/SocialLinks'
import PhoneLinks from '../Top/PhoneLinks/PhoneLinks'
import EmailLink from '../Top/EmailLink/EmailLink'
import { NavLink } from 'react-router-dom'
import Icon from '../../ui/Icon/Icon'
import { NavHashLink } from 'react-router-hash-link'
import scrollWithOffset from '../../ui/ScrollToTop/scrollWithOffset'
import SiteNavLink from '../Nav/SiteNavLink'

function Footer() {
  return (
    <footer id="contacts" className="Footer">
      <div className="Main DefaultContainer">
        <Logo />
        <div className="ContactBlock">
          <EmailLink />
          <PhoneLinks />
          {/* <SocialLinks /> */}
          <div className="Address">
            <div>
              <Icon name="map-marker-alt" weight="solid" />
              <span>г. Мурманск, ул Карла Либкнехта 46/4</span>
            </div>
            <a
              href="https://yandex.ru/maps/23/murmansk/house/ulitsa_karla_libknekhta_46k4/Z0oYdg9hSkUCQFhifXV5dXhrZw==/?ll=33.081304%2C68.984484&source=serp_navig&z=17"
              target="blank"
              className="SmallDesk"
            >
              Открыть схему проезда
            </a>
          </div>
        </div>
      </div>
      <div className="Footer-InfoContainer DefaultContainer">
        <SiteNavLink title="Наши номера" path="#numbers" />
        <SiteNavLink title="Групповое размещение" path="#group" />
        <SiteNavLink title="Наши преимущества" path="#benefits" />
        {/* <SiteNavLink title="Тур по хостелу" path="#tour" /> */}
        <SiteNavLink title="Отзывы" path="#feeds" />
        <SiteNavLink title="Контакты" path="#contacts" />
      </div>
      <div className="Copyrights DefaultContainer">
        © 2024 Все права защищены.{' '}
        <a href="/docs/policy.pdf" target="blank">
          Политика обработки персональных данных и конфиденциальности в
          отношении обработки персональных данных
        </a>
      </div>
    </footer>
  )
}

export default Footer
